import React from 'react';
import {Button} from 'antd';
import {Link} from "react-router-dom";
import './PaymentSuccess.css';

const PaymentSuccess = () => {
    return (
        <div className="home-banner">
            <div className="home-banner-holder">
                <div className="home-banner-content">
                    <h1 className="text-uppercase">
                        Plan Updated
                    </h1>
                    <p>
                        Thank you for using paradi service
                    </p>
                    <div className="home-banner-content-operations">
                        <Link to="/dashboard">
                            <Button type="primary" shape="round">
                                Back to home
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;